import React from "react";

const NextArrowIcon = () =>{

    return(
        <i className="fas fa-arrow-right-long me-2"></i>
    );
}

export default NextArrowIcon;